// extracted by mini-css-extract-plugin
export default {"visuallyHidden":"liveRegion_visuallyHidden__KgaDJ"};